function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (A, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.vueTagsInput = t() : A.vueTagsInput = t();
}(window, function () {
  return function (A) {
    var t = {};

    function e(n) {
      if (t[n]) return t[n].exports;
      var i = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return A[n].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }

    return e.m = A, e.c = t, e.d = function (A, t, n) {
      e.o(A, t) || Object.defineProperty(A, t, {
        enumerable: !0,
        get: n
      });
    }, e.r = function (A) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(A, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(A, "__esModule", {
        value: !0
      });
    }, e.t = function (A, t) {
      if (1 & t && (A = e(A)), 8 & t) return A;
      if (4 & t && "object" == _typeof(A) && A && A.__esModule) return A;
      var n = Object.create(null);
      if (e.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: A
      }), 2 & t && "string" != typeof A) for (var i in A) {
        e.d(n, i, function (t) {
          return A[t];
        }.bind(null, i));
      }
      return n;
    }, e.n = function (A) {
      var t = A && A.__esModule ? function () {
        return A.default;
      } : function () {
        return A;
      };
      return e.d(t, "a", t), t;
    }, e.o = function (A, t) {
      return Object.prototype.hasOwnProperty.call(A, t);
    }, e.p = "/dist/", e(e.s = 6);
  }([function (A, t, e) {
    var n = e(8);
    "string" == typeof n && (n = [[A.i, n, ""]]), n.locals && (A.exports = n.locals);
    (0, e(4).default)("7ec05f6c", n, !1, {});
  }, function (A, t, e) {
    var n = e(10);
    "string" == typeof n && (n = [[A.i, n, ""]]), n.locals && (A.exports = n.locals);
    (0, e(4).default)("3453d19d", n, !1, {});
  }, function (A, t, e) {
    "use strict";

    A.exports = function (A) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var e = function (A, t) {
            var e = A[1] || "",
                n = A[3];
            if (!n) return e;

            if (t && "function" == typeof btoa) {
              var i = (r = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */"),
                  a = n.sources.map(function (A) {
                return "/*# sourceURL=" + n.sourceRoot + A + " */";
              });
              return [e].concat(a).concat([i]).join("\n");
            }

            var r;
            return [e].join("\n");
          }(t, A);

          return t[2] ? "@media " + t[2] + "{" + e + "}" : e;
        }).join("");
      }, t.i = function (A, e) {
        "string" == typeof A && (A = [[null, A, ""]]);

        for (var n = {}, i = 0; i < this.length; i++) {
          var a = this[i][0];
          null != a && (n[a] = !0);
        }

        for (i = 0; i < A.length; i++) {
          var r = A[i];
          null != r[0] && n[r[0]] || (e && !r[2] ? r[2] = e : e && (r[2] = "(" + r[2] + ") and (" + e + ")"), t.push(r));
        }
      }, t;
    };
  }, function (A, t) {
    A.exports = "data:application/vnd.ms-fontobject;base64,aAUAAMQEAAABAAIAAAAAAAAAAAAAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAUdPJHwAAAAAAAAAAAAAAAAAAAAAAAA4AaQBjAG8AbQBvAG8AbgAAAA4AUgBlAGcAdQBsAGEAcgAAABYAVgBlAHIAcwBpAG8AbgAgADEALgAwAAAADgBpAGMAbwBtAG8AbwBuAAAAAAAAAQAAAAsAgAADADBPUy8yDxIFrAAAALwAAABgY21hcBdW0okAAAEcAAAAVGdhc3AAAAAQAAABcAAAAAhnbHlmpZ+jMAAAAXgAAAD8aGVhZA/FmAgAAAJ0AAAANmhoZWEHgAPIAAACrAAAACRobXR4EgABvgAAAtAAAAAcbG9jYQCSAOIAAALsAAAAEG1heHAACQAfAAAC/AAAACBuYW1lmUoJ+wAAAxwAAAGGcG9zdAADAAAAAASkAAAAIAADA4ABkAAFAAACmQLMAAAAjwKZAswAAAHrADMBCQAAAAAAAAAAAAAAAAAAAAEQAAAAAAAAAAAAAAAAAAAAAEAAAOkCA8D/wABAA8AAQAAAAAEAAAAAAAAAAAAAACAAAAAAAAMAAAADAAAAHAABAAMAAAAcAAMAAQAAABwABAA4AAAACgAIAAIAAgABACDpAv/9//8AAAAAACDpAP/9//8AAf/jFwQAAwABAAAAAAAAAAAAAAABAAH//wAPAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAVgEBA74CgQAcAAABMhceARcWFwcmJy4BJyYjIgYHFyERFzY3PgE3NgIWSkNDbykpF2QQIB9VMzQ5P3AtnP6AmB0iIkspKAJVFxhSODlCIDMrKz4REislmgGAmhkVFBwICAABANYAgQMqAtUACwAAAQcXBycHJzcnNxc3Ayru7jzu7jzu7jzu7gKZ7u487u487u487u4AAQCSAIEDgAK9AAUAACUBFwEnNwGAAcQ8/gDuPPkBxDz+AO48AAAAAAEAAAAAAAAfydNRXw889QALBAAAAAAA1nUqGwAAAADWdSobAAAAAAO+AtUAAAAIAAIAAAAAAAAAAQAAA8D/wAAABAAAAAAAA74AAQAAAAAAAAAAAAAAAAAAAAcEAAAAAAAAAAAAAAACAAAABAAAVgQAANYEAACSAAAAAAAKABQAHgBQAGoAfgABAAAABwAdAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEABwAAAAEAAAAAAAIABwBgAAEAAAAAAAMABwA2AAEAAAAAAAQABwB1AAEAAAAAAAUACwAVAAEAAAAAAAYABwBLAAEAAAAAAAoAGgCKAAMAAQQJAAEADgAHAAMAAQQJAAIADgBnAAMAAQQJAAMADgA9AAMAAQQJAAQADgB8AAMAAQQJAAUAFgAgAAMAAQQJAAYADgBSAAMAAQQJAAoANACkaWNvbW9vbgBpAGMAbwBtAG8AbwBuVmVyc2lvbiAxLjAAVgBlAHIAcwBpAG8AbgAgADEALgAwaWNvbW9vbgBpAGMAbwBtAG8AbwBuaWNvbW9vbgBpAGMAbwBtAG8AbwBuUmVndWxhcgBSAGUAZwB1AGwAYQByaWNvbW9vbgBpAGMAbwBtAG8AbwBuRm9udCBnZW5lcmF0ZWQgYnkgSWNvTW9vbi4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==";
  }, function (A, t, e) {
    "use strict";

    function n(A, t) {
      for (var e = [], n = {}, i = 0; i < t.length; i++) {
        var a = t[i],
            r = a[0],
            o = {
          id: A + ":" + i,
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        n[r] ? n[r].parts.push(o) : e.push(n[r] = {
          id: r,
          parts: [o]
        });
      }

      return e;
    }

    e.r(t), e.d(t, "default", function () {
      return g;
    });
    var i = "undefined" != typeof document;
    if ("undefined" != typeof DEBUG && DEBUG && !i) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");

    var a = {},
        r = i && (document.head || document.getElementsByTagName("head")[0]),
        o = null,
        s = 0,
        u = !1,
        c = function c() {},
        d = null,
        l = "data-vue-ssr-id",
        p = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

    function g(A, t, e, i) {
      u = e, d = i || {};
      var r = n(A, t);
      return f(r), function (t) {
        for (var e = [], i = 0; i < r.length; i++) {
          var o = r[i];
          (s = a[o.id]).refs--, e.push(s);
        }

        t ? f(r = n(A, t)) : r = [];

        for (i = 0; i < e.length; i++) {
          var s;

          if (0 === (s = e[i]).refs) {
            for (var u = 0; u < s.parts.length; u++) {
              s.parts[u]();
            }

            delete a[s.id];
          }
        }
      };
    }

    function f(A) {
      for (var t = 0; t < A.length; t++) {
        var e = A[t],
            n = a[e.id];

        if (n) {
          n.refs++;

          for (var i = 0; i < n.parts.length; i++) {
            n.parts[i](e.parts[i]);
          }

          for (; i < e.parts.length; i++) {
            n.parts.push(v(e.parts[i]));
          }

          n.parts.length > e.parts.length && (n.parts.length = e.parts.length);
        } else {
          var r = [];

          for (i = 0; i < e.parts.length; i++) {
            r.push(v(e.parts[i]));
          }

          a[e.id] = {
            id: e.id,
            refs: 1,
            parts: r
          };
        }
      }
    }

    function B() {
      var A = document.createElement("style");
      return A.type = "text/css", r.appendChild(A), A;
    }

    function v(A) {
      var t,
          e,
          n = document.querySelector("style[" + l + '~="' + A.id + '"]');

      if (n) {
        if (u) return c;
        n.parentNode.removeChild(n);
      }

      if (p) {
        var i = s++;
        n = o || (o = B()), t = C.bind(null, n, i, !1), e = C.bind(null, n, i, !0);
      } else n = B(), t = function (A, t) {
        var e = t.css,
            n = t.media,
            i = t.sourceMap;
        n && A.setAttribute("media", n);
        d.ssrId && A.setAttribute(l, t.id);
        i && (e += "\n/*# sourceURL=" + i.sources[0] + " */", e += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        if (A.styleSheet) A.styleSheet.cssText = e;else {
          for (; A.firstChild;) {
            A.removeChild(A.firstChild);
          }

          A.appendChild(document.createTextNode(e));
        }
      }.bind(null, n), e = function e() {
        n.parentNode.removeChild(n);
      };

      return t(A), function (n) {
        if (n) {
          if (n.css === A.css && n.media === A.media && n.sourceMap === A.sourceMap) return;
          t(A = n);
        } else e();
      };
    }

    var m,
        h = (m = [], function (A, t) {
      return m[A] = t, m.filter(Boolean).join("\n");
    });

    function C(A, t, e, n) {
      var i = e ? "" : n.css;
      if (A.styleSheet) A.styleSheet.cssText = h(t, i);else {
        var a = document.createTextNode(i),
            r = A.childNodes;
        r[t] && A.removeChild(r[t]), r.length ? A.insertBefore(a, r[t]) : A.appendChild(a);
      }
    }
  }, function (A, t, e) {
    "use strict";

    var n = Array.isArray,
        i = Object.keys,
        a = Object.prototype.hasOwnProperty;

    A.exports = function A(t, e) {
      if (t === e) return !0;

      if (t && e && "object" == _typeof(t) && "object" == _typeof(e)) {
        var r,
            o,
            s,
            u = n(t),
            c = n(e);

        if (u && c) {
          if ((o = t.length) != e.length) return !1;

          for (r = o; 0 != r--;) {
            if (!A(t[r], e[r])) return !1;
          }

          return !0;
        }

        if (u != c) return !1;
        var d = t instanceof Date,
            l = e instanceof Date;
        if (d != l) return !1;
        if (d && l) return t.getTime() == e.getTime();
        var p = t instanceof RegExp,
            g = e instanceof RegExp;
        if (p != g) return !1;
        if (p && g) return t.toString() == e.toString();
        var f = i(t);
        if ((o = f.length) !== i(e).length) return !1;

        for (r = o; 0 != r--;) {
          if (!a.call(e, f[r])) return !1;
        }

        for (r = o; 0 != r--;) {
          if (!A(t[s = f[r]], e[s])) return !1;
        }

        return !0;
      }

      return t != t && e != e;
    };
  }, function (A, t, e) {
    A.exports = e(14);
  }, function (A, t, e) {
    "use strict";

    var n = e(0);
    e.n(n).a;
  }, function (A, t, e) {
    (A.exports = e(2)(!0)).push([A.i, ".ti-tag-input[data-v-108f4f13] {\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  display: flex;\n  top: 0px;\n  position: absolute;\n  width: 100%;\n  line-height: inherit;\n}\n.ti-tag-input[data-v-108f4f13]::-ms-clear {\n  display: none;\n}\ninput[data-v-108f4f13]:focus {\n  outline: none;\n}\ninput[disabled][data-v-108f4f13] {\n  background-color: transparent;\n}\n", "", {
      version: 3,
      sources: ["C:/Users/johan/dev/vue-tags-input/vue-tags-input/C:/Users/johan/dev/vue-tags-input/vue-tags-input/tag-input.vue"],
      names: [],
      mappings: "AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;CAAE;AAEzB;EACE,cAAc;CAAE;AAElB;EACE,cAAc;CAAE;AAElB;EACE,8BAA8B;CAAE",
      file: "tag-input.vue?vue&type=style&index=0&id=108f4f13&lang=css&scoped=true&",
      sourcesContent: [".ti-tag-input {\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  display: flex;\n  top: 0px;\n  position: absolute;\n  width: 100%;\n  line-height: inherit; }\n\n.ti-tag-input::-ms-clear {\n  display: none; }\n\ninput:focus {\n  outline: none; }\n\ninput[disabled] {\n  background-color: transparent; }\n"],
      sourceRoot: ""
    }]);
  }, function (A, t, e) {
    "use strict";

    var n = e(1);
    e.n(n).a;
  }, function (A, t, e) {
    t = A.exports = e(2)(!0);
    var n = e(11),
        i = n(e(3)),
        a = n(e(3) + "#iefix"),
        r = n(e(12)),
        o = n(e(13));
    t.push([A.i, "@font-face {\n  font-family: 'icomoon';\n  src: url(" + i + ");\n  src: url(" + a + ') format("embedded-opentype"), url(' + r + ') format("truetype"), url(' + o + ') format("woff");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^="ti-icon-"][data-v-61d92e31], [class*=" ti-icon-"][data-v-61d92e31] {\n  font-family: \'icomoon\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.ti-icon-check[data-v-61d92e31]:before {\n  content: "\\e902";\n}\n.ti-icon-close[data-v-61d92e31]:before {\n  content: "\\e901";\n}\n.ti-icon-undo[data-v-61d92e31]:before {\n  content: "\\e900";\n}\nul[data-v-61d92e31] {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n}\n*[data-v-61d92e31], *[data-v-61d92e31]:before, *[data-v-61d92e31]:after {\n  box-sizing: border-box;\n}\ninput[data-v-61d92e31]:focus {\n  outline: none;\n}\ninput[disabled][data-v-61d92e31] {\n  background-color: transparent;\n}\n.vue-tags-input[data-v-61d92e31] {\n  max-width: 450px;\n  position: relative;\n  background-color: #fff;\n}\ndiv.vue-tags-input.disabled[data-v-61d92e31] {\n  opacity: 0.5;\n}\ndiv.vue-tags-input.disabled *[data-v-61d92e31] {\n    cursor: default;\n}\n.ti-input[data-v-61d92e31] {\n  border: 1px solid #ccc;\n  display: flex;\n  padding: 4px;\n  flex-wrap: wrap;\n}\n.ti-tags[data-v-61d92e31] {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  line-height: 1em;\n}\n.ti-tag[data-v-61d92e31] {\n  background-color: #5C6BC0;\n  color: #fff;\n  border-radius: 2px;\n  display: flex;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em;\n}\n.ti-tag[data-v-61d92e31]:focus {\n    outline: none;\n}\n.ti-tag .ti-content[data-v-61d92e31] {\n    display: flex;\n    align-items: center;\n}\n.ti-tag .ti-tag-center[data-v-61d92e31] {\n    position: relative;\n}\n.ti-tag span[data-v-61d92e31] {\n    line-height: .85em;\n}\n.ti-tag span.ti-hidden[data-v-61d92e31] {\n    padding-left: 14px;\n    visibility: hidden;\n    height: 0px;\n    white-space: pre;\n}\n.ti-tag .ti-actions[data-v-61d92e31] {\n    margin-left: 2px;\n    display: flex;\n    align-items: center;\n    font-size: 1.15em;\n}\n.ti-tag .ti-actions i[data-v-61d92e31] {\n      cursor: pointer;\n}\n.ti-tag[data-v-61d92e31]:last-child {\n    margin-right: 4px;\n}\n.ti-tag.ti-invalid[data-v-61d92e31], .ti-tag.ti-tag.ti-deletion-mark[data-v-61d92e31] {\n    background-color: #e54d42;\n}\n.ti-new-tag-input-wrapper[data-v-61d92e31] {\n  display: flex;\n  flex: 1 0 auto;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em;\n}\n.ti-new-tag-input-wrapper input[data-v-61d92e31] {\n    flex: 1 0 auto;\n    min-width: 100px;\n    border: none;\n    padding: 0px;\n    margin: 0px;\n}\n.ti-new-tag-input[data-v-61d92e31] {\n  line-height: initial;\n}\n.ti-autocomplete[data-v-61d92e31] {\n  border: 1px solid #ccc;\n  border-top: none;\n  position: absolute;\n  width: 100%;\n  background-color: #fff;\n  z-index: 20;\n}\n.ti-item > div[data-v-61d92e31] {\n  cursor: pointer;\n  padding: 3px 6px;\n  width: 100%;\n}\n.ti-selected-item[data-v-61d92e31] {\n  background-color: #5C6BC0;\n  color: #fff;\n}\n', "", {
      version: 3,
      sources: ["C:/Users/johan/dev/vue-tags-input/vue-tags-input/C:/Users/johan/dev/vue-tags-input/vue-tags-input/vue-tags-input.scss"],
      names: [],
      mappings: "AAAA;EACE,uBAAuB;EACvB,mCAA8C;EAC9C,+JAAuM;EACvM,oBAAoB;EACpB,mBAAmB;CAAE;AAEvB;EACE,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,mCAAmC;CAAE;AAEvC;EACE,iBAAiB;CAAE;AAErB;EACE,iBAAiB;CAAE;AAErB;EACE,iBAAiB;CAAE;AAErB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;CAAE;AAE1B;EACE,uBAAuB;CAAE;AAE3B;EACE,cAAc;CAAE;AAElB;EACE,8BAA8B;CAAE;AAElC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;CAAE;AAE3B;EACE,aAAa;CAAE;AACf;IACE,gBAAgB;CAAE;AAEtB;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;CAAE;AAEpB;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAAE;AAErB;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;CAAE;AACnB;IACE,cAAc;CAAE;AAClB;IACE,cAAc;IACd,oBAAoB;CAAE;AACxB;IACE,mBAAmB;CAAE;AACvB;IACE,mBAAmB;CAAE;AACvB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;CAAE;AACrB;IACE,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;CAAE;AACpB;MACE,gBAAgB;CAAE;AACtB;IACE,kBAAkB;CAAE;AACtB;IACE,0BAA0B;CAAE;AAEhC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;CAAE;AACnB;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,YAAY;CAAE;AAElB;EACE,qBAAqB;CAAE;AAEzB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;CAAE;AAEhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CAAE;AAEhB;EACE,0BAA0B;EAC1B,YAAY;CAAE",
      file: "vue-tags-input.scss?vue&type=style&index=0&id=61d92e31&lang=scss&scoped=true&",
      sourcesContent: ['@font-face {\n  font-family: \'icomoon\';\n  src: url("./assets/fonts/icomoon.eot?7grlse");\n  src: url("./assets/fonts/icomoon.eot?7grlse#iefix") format("embedded-opentype"), url("./assets/fonts/icomoon.ttf?7grlse") format("truetype"), url("./assets/fonts/icomoon.woff?7grlse") format("woff");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^="ti-icon-"], [class*=" ti-icon-"] {\n  font-family: \'icomoon\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.ti-icon-check:before {\n  content: "\\e902"; }\n\n.ti-icon-close:before {\n  content: "\\e901"; }\n\n.ti-icon-undo:before {\n  content: "\\e900"; }\n\nul {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none; }\n\n*, *:before, *:after {\n  box-sizing: border-box; }\n\ninput:focus {\n  outline: none; }\n\ninput[disabled] {\n  background-color: transparent; }\n\n.vue-tags-input {\n  max-width: 450px;\n  position: relative;\n  background-color: #fff; }\n\ndiv.vue-tags-input.disabled {\n  opacity: 0.5; }\n  div.vue-tags-input.disabled * {\n    cursor: default; }\n\n.ti-input {\n  border: 1px solid #ccc;\n  display: flex;\n  padding: 4px;\n  flex-wrap: wrap; }\n\n.ti-tags {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  line-height: 1em; }\n\n.ti-tag {\n  background-color: #5C6BC0;\n  color: #fff;\n  border-radius: 2px;\n  display: flex;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em; }\n  .ti-tag:focus {\n    outline: none; }\n  .ti-tag .ti-content {\n    display: flex;\n    align-items: center; }\n  .ti-tag .ti-tag-center {\n    position: relative; }\n  .ti-tag span {\n    line-height: .85em; }\n  .ti-tag span.ti-hidden {\n    padding-left: 14px;\n    visibility: hidden;\n    height: 0px;\n    white-space: pre; }\n  .ti-tag .ti-actions {\n    margin-left: 2px;\n    display: flex;\n    align-items: center;\n    font-size: 1.15em; }\n    .ti-tag .ti-actions i {\n      cursor: pointer; }\n  .ti-tag:last-child {\n    margin-right: 4px; }\n  .ti-tag.ti-invalid, .ti-tag.ti-tag.ti-deletion-mark {\n    background-color: #e54d42; }\n\n.ti-new-tag-input-wrapper {\n  display: flex;\n  flex: 1 0 auto;\n  padding: 3px 5px;\n  margin: 2px;\n  font-size: .85em; }\n  .ti-new-tag-input-wrapper input {\n    flex: 1 0 auto;\n    min-width: 100px;\n    border: none;\n    padding: 0px;\n    margin: 0px; }\n\n.ti-new-tag-input {\n  line-height: initial; }\n\n.ti-autocomplete {\n  border: 1px solid #ccc;\n  border-top: none;\n  position: absolute;\n  width: 100%;\n  background-color: #fff;\n  z-index: 20; }\n\n.ti-item > div {\n  cursor: pointer;\n  padding: 3px 6px;\n  width: 100%; }\n\n.ti-selected-item {\n  background-color: #5C6BC0;\n  color: #fff; }\n'],
      sourceRoot: ""
    }]);
  }, function (A, t, e) {
    "use strict";

    A.exports = function (A) {
      return "string" != typeof A ? A : (/^['"].*['"]$/.test(A) && (A = A.slice(1, -1)), /["'() \t\n]/.test(A) ? '"' + A.replace(/"/g, '\\"').replace(/\n/g, "\\n") + '"' : A);
    };
  }, function (A, t) {
    A.exports = "data:font/ttf;base64,AAEAAAALAIAAAwAwT1MvMg8SBawAAAC8AAAAYGNtYXAXVtKJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZqWfozAAAAF4AAAA/GhlYWQPxZgIAAACdAAAADZoaGVhB4ADyAAAAqwAAAAkaG10eBIAAb4AAALQAAAAHGxvY2EAkgDiAAAC7AAAABBtYXhwAAkAHwAAAvwAAAAgbmFtZZlKCfsAAAMcAAABhnBvc3QAAwAAAAAEpAAAACAAAwOAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6QL//f//AAAAAAAg6QD//f//AAH/4xcEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAFYBAQO+AoEAHAAAATIXHgEXFhcHJicuAScmIyIGBxchERc2Nz4BNzYCFkpDQ28pKRdkECAfVTM0OT9wLZz+gJgdIiJLKSgCVRcYUjg5QiAzKys+ERIrJZoBgJoZFRQcCAgAAQDWAIEDKgLVAAsAAAEHFwcnByc3JzcXNwMq7u487u487u487u4Cme7uPO7uPO7uPO7uAAEAkgCBA4ACvQAFAAAlARcBJzcBgAHEPP4A7jz5AcQ8/gDuPAAAAAABAAAAAAAAH8nTUV8PPPUACwQAAAAAANZ1KhsAAAAA1nUqGwAAAAADvgLVAAAACAACAAAAAAAAAAEAAAPA/8AAAAQAAAAAAAO+AAEAAAAAAAAAAAAAAAAAAAAHBAAAAAAAAAAAAAAAAgAAAAQAAFYEAADWBAAAkgAAAAAACgAUAB4AUABqAH4AAQAAAAcAHQABAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAcAAAABAAAAAAACAAcAYAABAAAAAAADAAcANgABAAAAAAAEAAcAdQABAAAAAAAFAAsAFQABAAAAAAAGAAcASwABAAAAAAAKABoAigADAAEECQABAA4ABwADAAEECQACAA4AZwADAAEECQADAA4APQADAAEECQAEAA4AfAADAAEECQAFABYAIAADAAEECQAGAA4AUgADAAEECQAKADQApGljb21vb24AaQBjAG8AbQBvAG8AblZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMGljb21vb24AaQBjAG8AbQBvAG8Abmljb21vb24AaQBjAG8AbQBvAG8AblJlZ3VsYXIAUgBlAGcAdQBsAGEAcmljb21vb24AaQBjAG8AbQBvAG8AbkZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";
  }, function (A, t) {
    A.exports = "data:font/woff;base64,d09GRgABAAAAAAUQAAsAAAAABMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABCAAAAGAAAABgDxIFrGNtYXAAAAFoAAAAVAAAAFQXVtKJZ2FzcAAAAbwAAAAIAAAACAAAABBnbHlmAAABxAAAAPwAAAD8pZ+jMGhlYWQAAALAAAAANgAAADYPxZgIaGhlYQAAAvgAAAAkAAAAJAeAA8hobXR4AAADHAAAABwAAAAcEgABvmxvY2EAAAM4AAAAEAAAABAAkgDibWF4cAAAA0gAAAAgAAAAIAAJAB9uYW1lAAADaAAAAYYAAAGGmUoJ+3Bvc3QAAATwAAAAIAAAACAAAwAAAAMDgAGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA6QIDwP/AAEADwABAAAAAAQAAAAAAAAAAAAAAIAAAAAAAAwAAAAMAAAAcAAEAAwAAABwAAwABAAAAHAAEADgAAAAKAAgAAgACAAEAIOkC//3//wAAAAAAIOkA//3//wAB/+MXBAADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQBWAQEDvgKBABwAAAEyFx4BFxYXByYnLgEnJiMiBgcXIREXNjc+ATc2AhZKQ0NvKSkXZBAgH1UzNDk/cC2c/oCYHSIiSykoAlUXGFI4OUIgMysrPhESKyWaAYCaGRUUHAgIAAEA1gCBAyoC1QALAAABBxcHJwcnNyc3FzcDKu7uPO7uPO7uPO7uApnu7jzu7jzu7jzu7gABAJIAgQOAAr0ABQAAJQEXASc3AYABxDz+AO48+QHEPP4A7jwAAAAAAQAAAAAAAB/J01FfDzz1AAsEAAAAAADWdSobAAAAANZ1KhsAAAAAA74C1QAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADvgABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABWBAAA1gQAAJIAAAAAAAoAFAAeAFAAagB+AAEAAAAHAB0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAHAAAAAQAAAAAAAgAHAGAAAQAAAAAAAwAHADYAAQAAAAAABAAHAHUAAQAAAAAABQALABUAAQAAAAAABgAHAEsAAQAAAAAACgAaAIoAAwABBAkAAQAOAAcAAwABBAkAAgAOAGcAAwABBAkAAwAOAD0AAwABBAkABAAOAHwAAwABBAkABQAWACAAAwABBAkABgAOAFIAAwABBAkACgA0AKRpY29tb29uAGkAYwBvAG0AbwBvAG5WZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBpY29tb29uAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG5SZWd1bGFyAFIAZQBnAHUAbABhAHJpY29tb29uAGkAYwBvAG0AbwBvAG5Gb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";
  }, function (A, t, e) {
    "use strict";

    e.r(t);

    var n = function n() {
      var A = this,
          t = A.$createElement,
          e = A._self._c || t;
      return e("div", {
        staticClass: "vue-tags-input",
        class: [{
          "ti-disabled": A.disabled
        }, {
          "ti-focus": A.focused
        }]
      }, [e("div", {
        staticClass: "ti-input"
      }, [A.tagsCopy ? e("ul", {
        staticClass: "ti-tags"
      }, [A._l(A.tagsCopy, function (t, n) {
        return e("li", {
          key: n,
          staticClass: "ti-tag",
          class: [{
            "ti-editing": A.tagsEditStatus[n]
          }, t.tiClasses, t.classes, {
            "ti-deletion-mark": A.isMarked(n)
          }],
          style: t.style,
          attrs: {
            tabindex: "0"
          },
          on: {
            click: function click(e) {
              return A.$emit("tag-clicked", {
                tag: t,
                index: n
              });
            }
          }
        }, [e("div", {
          staticClass: "ti-content"
        }, [A.$scopedSlots["tag-left"] ? e("div", {
          staticClass: "ti-tag-left"
        }, [A._t("tag-left", null, {
          tag: t,
          index: n,
          edit: A.tagsEditStatus[n],
          performSaveEdit: A.performSaveTag,
          performDelete: A.performDeleteTag,
          performCancelEdit: A.cancelEdit,
          performOpenEdit: A.performEditTag,
          deletionMark: A.isMarked(n)
        })], 2) : A._e(), A._v(" "), e("div", {
          ref: "tagCenter",
          refInFor: !0,
          staticClass: "ti-tag-center"
        }, [A.$scopedSlots["tag-center"] ? A._e() : e("span", {
          class: {
            "ti-hidden": A.tagsEditStatus[n]
          },
          on: {
            click: function click(t) {
              return A.performEditTag(n);
            }
          }
        }, [A._v(A._s(t.text))]), A._v(" "), A.$scopedSlots["tag-center"] ? A._e() : e("tag-input", {
          attrs: {
            scope: {
              edit: A.tagsEditStatus[n],
              maxlength: A.maxlength,
              tag: t,
              index: n,
              validateTag: A.createChangedTag,
              performCancelEdit: A.cancelEdit,
              performSaveEdit: A.performSaveTag
            }
          }
        }), A._v(" "), A._t("tag-center", null, {
          tag: t,
          index: n,
          maxlength: A.maxlength,
          edit: A.tagsEditStatus[n],
          performSaveEdit: A.performSaveTag,
          performDelete: A.performDeleteTag,
          performCancelEdit: A.cancelEdit,
          validateTag: A.createChangedTag,
          performOpenEdit: A.performEditTag,
          deletionMark: A.isMarked(n)
        })], 2), A._v(" "), A.$scopedSlots["tag-right"] ? e("div", {
          staticClass: "ti-tag-right"
        }, [A._t("tag-right", null, {
          tag: t,
          index: n,
          edit: A.tagsEditStatus[n],
          performSaveEdit: A.performSaveTag,
          performDelete: A.performDeleteTag,
          performCancelEdit: A.cancelEdit,
          performOpenEdit: A.performEditTag,
          deletionMark: A.isMarked(n)
        })], 2) : A._e()]), A._v(" "), e("div", {
          staticClass: "ti-actions"
        }, [A.$scopedSlots["tag-actions"] ? A._e() : e("i", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: A.tagsEditStatus[n],
            expression: "tagsEditStatus[index]"
          }],
          staticClass: "ti-icon-undo",
          on: {
            click: function click(t) {
              return A.cancelEdit(n);
            }
          }
        }), A._v(" "), A.$scopedSlots["tag-actions"] ? A._e() : e("i", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !A.tagsEditStatus[n],
            expression: "!tagsEditStatus[index]"
          }],
          staticClass: "ti-icon-close",
          on: {
            click: function click(t) {
              return A.performDeleteTag(n);
            }
          }
        }), A._v(" "), A.$scopedSlots["tag-actions"] ? A._t("tag-actions", null, {
          tag: t,
          index: n,
          edit: A.tagsEditStatus[n],
          performSaveEdit: A.performSaveTag,
          performDelete: A.performDeleteTag,
          performCancelEdit: A.cancelEdit,
          performOpenEdit: A.performEditTag,
          deletionMark: A.isMarked(n)
        }) : A._e()], 2)]);
      }), A._v(" "), e("li", {
        staticClass: "ti-new-tag-input-wrapper"
      }, [e("input", A._b({
        ref: "newTagInput",
        staticClass: "ti-new-tag-input",
        class: [A.createClasses(A.newTag, A.tags, A.validation, A.isDuplicate)],
        attrs: {
          placeholder: A.placeholder,
          maxlength: A.maxlength,
          disabled: A.disabled,
          type: "text",
          size: "1"
        },
        domProps: {
          value: A.newTag
        },
        on: {
          keydown: [function (t) {
            return A.performAddTags(A.filteredAutocompleteItems[A.selectedItem] || A.newTag, t);
          }, function (t) {
            return t.type.indexOf("key") || 8 === t.keyCode ? A.invokeDelete(t) : null;
          }, function (t) {
            return t.type.indexOf("key") || 9 === t.keyCode ? A.performBlur(t) : null;
          }, function (t) {
            return t.type.indexOf("key") || 38 === t.keyCode ? A.selectItem(t, "before") : null;
          }, function (t) {
            return t.type.indexOf("key") || 40 === t.keyCode ? A.selectItem(t, "after") : null;
          }],
          paste: A.addTagsFromPaste,
          input: A.updateNewTag,
          blur: function blur(t) {
            return A.$emit("blur", t);
          },
          focus: function focus(t) {
            A.focused = !0, A.$emit("focus", t);
          },
          click: function click(t) {
            !A.addOnlyFromAutocomplete && (A.selectedItem = null);
          }
        }
      }, "input", A.$attrs, !1))])], 2) : A._e()]), A._v(" "), A._t("between-elements"), A._v(" "), A.autocompleteOpen ? e("div", {
        staticClass: "ti-autocomplete",
        on: {
          mouseout: function mouseout(t) {
            A.selectedItem = null;
          }
        }
      }, [A._t("autocomplete-header"), A._v(" "), e("ul", A._l(A.filteredAutocompleteItems, function (t, n) {
        return e("li", {
          key: n,
          staticClass: "ti-item",
          class: [t.tiClasses, t.classes, {
            "ti-selected-item": A.isSelected(n)
          }],
          style: t.style,
          on: {
            mouseover: function mouseover(t) {
              !A.disabled && (A.selectedItem = n);
            }
          }
        }, [A.$scopedSlots["autocomplete-item"] ? A._t("autocomplete-item", null, {
          item: t,
          index: n,
          performAdd: function performAdd(t) {
            return A.performAddTags(t, void 0, "autocomplete");
          },
          selected: A.isSelected(n)
        }) : e("div", {
          on: {
            click: function click(e) {
              return A.performAddTags(t, void 0, "autocomplete");
            }
          }
        }, [A._v("\n          " + A._s(t.text) + "\n        ")])], 2);
      }), 0), A._v(" "), A._t("autocomplete-footer")], 2) : A._e()], 2);
    };

    n._withStripped = !0;

    var i = e(5),
        a = e.n(i),
        r = function r(A) {
      return JSON.parse(JSON.stringify(A));
    },
        o = function o(A, t) {
      var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
          n = arguments.length > 3 ? arguments[3] : void 0;
      void 0 === A.text && (A = {
        text: A
      });

      var i = function (A, t) {
        return t.filter(function (t) {
          var e = A.text;
          return "string" == typeof t.rule ? !new RegExp(t.rule).test(e) : t.rule instanceof RegExp ? !t.rule.test(e) : "[object Function]" === {}.toString.call(t.rule) ? t.rule(A) : void 0;
        }).map(function (A) {
          return A.classes;
        });
      }(A, e),
          a = function (A, t) {
        for (var e = 0; e < A.length;) {
          if (t(A[e], e, A)) return e;
          e++;
        }

        return -1;
      }(t, function (t) {
        return t === A;
      }),
          o = r(t),
          s = -1 !== a ? o.splice(a, 1)[0] : r(A);

      return (n ? n(o, s) : -1 !== o.map(function (A) {
        return A.text;
      }).indexOf(s.text)) && i.push("ti-duplicate"), 0 === i.length ? i.push("ti-valid") : i.push("ti-invalid"), i;
    },
        s = function s(A) {
      void 0 === A.text && (A = {
        text: A
      });

      for (var t = r(A), e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) {
        n[i - 1] = arguments[i];
      }

      return t.tiClasses = o.apply(void 0, [A].concat(n)), t;
    },
        u = function u(A) {
      for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        e[n - 1] = arguments[n];
      }

      return A.map(function (t) {
        return s.apply(void 0, [t, A].concat(e));
      });
    },
        c = function c() {
      var A = this,
          t = A.$createElement,
          e = A._self._c || t;
      return A.scope.edit ? e("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: A.scope.tag.text,
          expression: "scope.tag.text"
        }],
        staticClass: "ti-tag-input",
        attrs: {
          maxlength: A.scope.maxlength,
          type: "text",
          size: "1"
        },
        domProps: {
          value: A.scope.tag.text
        },
        on: {
          input: [function (t) {
            t.target.composing || A.$set(A.scope.tag, "text", t.target.value);
          }, function (t) {
            return A.scope.validateTag(A.scope.index, t);
          }],
          blur: function blur(t) {
            return A.scope.performCancelEdit(A.scope.index);
          },
          keydown: function keydown(t) {
            return A.scope.performSaveEdit(A.scope.index, t);
          }
        }
      }) : A._e();
    };

    c._withStripped = !0;
    var d = {
      name: "TagInput",
      props: {
        scope: {
          type: Object
        }
      }
    };
    e(7);

    function l(A, t, e, n, i, a, r, o) {
      var s,
          u = "function" == typeof A ? A.options : A;
      if (t && (u.render = t, u.staticRenderFns = e, u._compiled = !0), n && (u.functional = !0), a && (u._scopeId = "data-v-" + a), r ? (s = function s(A) {
        (A = A || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (A = __VUE_SSR_CONTEXT__), i && i.call(this, A), A && A._registeredComponents && A._registeredComponents.add(r);
      }, u._ssrRegister = s) : i && (s = o ? function () {
        i.call(this, this.$root.$options.shadowRoot);
      } : i), s) if (u.functional) {
        u._injectStyles = s;
        var c = u.render;

        u.render = function (A, t) {
          return s.call(t), c(A, t);
        };
      } else {
        var d = u.beforeCreate;
        u.beforeCreate = d ? [].concat(d, s) : [s];
      }
      return {
        exports: A,
        options: u
      };
    }

    var p = l(d, c, [], !1, null, "108f4f13", null);
    p.options.__file = "vue-tags-input/tag-input.vue";

    var g = p.exports,
        f = function f(A) {
      return !A.some(function (A) {
        var t = !A.text;
        t && console.warn('Missing property "text"', A);
        var e = !1;
        return A.classes && (e = "string" != typeof A.classes), e && console.warn('Property "classes" must be type of string', A), t || e;
      });
    },
        B = function B(A) {
      return !A.some(function (A) {
        if ("number" == typeof A) {
          var t = isFinite(A) && Math.floor(A) === A;
          return t || console.warn("Only numerics are allowed for this prop. Found:", A), !t;
        }

        if ("string" == typeof A) {
          var e = /\W|[a-z]|!\d/i.test(A);
          return e || console.warn("Only alpha strings are allowed for this prop. Found:", A), !e;
        }

        return console.warn("Only numeric and string values are allowed. Found:", A), !1;
      });
    },
        v = {
      value: {
        type: String,
        default: "",
        required: !0
      },
      tags: {
        type: Array,
        default: function _default() {
          return [];
        },
        validator: f
      },
      autocompleteItems: {
        type: Array,
        default: function _default() {
          return [];
        },
        validator: f
      },
      allowEditTags: {
        type: Boolean,
        default: !1
      },
      autocompleteFilterDuplicates: {
        default: !0,
        type: Boolean
      },
      addOnlyFromAutocomplete: {
        type: Boolean,
        default: !1
      },
      autocompleteMinLength: {
        type: Number,
        default: 1
      },
      autocompleteAlwaysOpen: {
        type: Boolean,
        default: !1
      },
      disabled: {
        type: Boolean,
        default: !1
      },
      placeholder: {
        type: String,
        default: "Add Tag"
      },
      addOnKey: {
        type: Array,
        default: function _default() {
          return [13];
        },
        validator: B
      },
      saveOnKey: {
        type: Array,
        default: function _default() {
          return [13];
        },
        validator: B
      },
      maxTags: {
        type: Number
      },
      maxlength: {
        type: Number
      },
      validation: {
        type: Array,
        default: function _default() {
          return [];
        },
        validator: function validator(A) {
          return !A.some(function (A) {
            var t = !A.rule;
            t && console.warn('Property "rule" is missing', A);
            var e = A.rule && ("string" == typeof A.rule || A.rule instanceof RegExp || "[object Function]" === {}.toString.call(A.rule));
            e || console.warn("A rule must be type of string, RegExp or function. Found:", JSON.stringify(A.rule));
            var n = !A.classes;
            n && console.warn('Property "classes" is missing', A);
            var i = A.type && "string" != typeof A.type;
            return i && console.warn('Property "type" must be type of string. Found:', A), !e || t || n || i;
          });
        }
      },
      separators: {
        type: Array,
        default: function _default() {
          return [";"];
        },
        validator: function validator(A) {
          return !A.some(function (A) {
            var t = "string" != typeof A;
            return t && console.warn("Separators must be type of string. Found:", A), t;
          });
        }
      },
      avoidAddingDuplicates: {
        type: Boolean,
        default: !0
      },
      addOnBlur: {
        type: Boolean,
        default: !0
      },
      isDuplicate: {
        type: Function,
        default: null
      },
      addFromPaste: {
        type: Boolean,
        default: !0
      },
      deleteOnBackspace: {
        default: !0,
        type: Boolean
      }
    };

    function m(A) {
      return (m = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (A) {
        return _typeof(A);
      } : function (A) {
        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : _typeof(A);
      })(A);
    }

    var h = {
      name: "VueTagsInput",
      components: {
        TagInput: g
      },
      props: v,
      data: function data() {
        return {
          newTag: null,
          tagsCopy: null,
          tagsEditStatus: null,
          deletionMark: null,
          deletionMarkTime: null,
          selectedItem: null,
          focused: null
        };
      },
      computed: {
        autocompleteOpen: function autocompleteOpen() {
          return !!this.autocompleteAlwaysOpen || null !== this.newTag && this.newTag.length >= this.autocompleteMinLength && this.filteredAutocompleteItems.length > 0 && this.focused;
        },
        filteredAutocompleteItems: function filteredAutocompleteItems() {
          var A = this,
              t = this.autocompleteItems.map(function (t) {
            return s(t, A.tags, A.validation, A.isDuplicate);
          });
          return this.autocompleteFilterDuplicates ? t.filter(this.duplicateFilter) : t;
        }
      },
      methods: {
        createClasses: o,
        getSelectedIndex: function getSelectedIndex(A) {
          var t = this.filteredAutocompleteItems,
              e = this.selectedItem,
              n = t.length - 1;
          if (0 !== t.length) return null === e ? 0 : "before" === A && 0 === e ? n : "after" === A && e === n ? 0 : "after" === A ? e + 1 : e - 1;
        },
        selectDefaultItem: function selectDefaultItem() {
          this.addOnlyFromAutocomplete && this.filteredAutocompleteItems.length > 0 ? this.selectedItem = 0 : this.selectedItem = null;
        },
        selectItem: function selectItem(A, t) {
          A.preventDefault(), this.selectedItem = this.getSelectedIndex(t);
        },
        isSelected: function isSelected(A) {
          return this.selectedItem === A;
        },
        isMarked: function isMarked(A) {
          return this.deletionMark === A;
        },
        invokeDelete: function invokeDelete() {
          var A = this;

          if (this.deleteOnBackspace && !(this.newTag.length > 0)) {
            var t = this.tagsCopy.length - 1;
            null === this.deletionMark ? (this.deletionMarkTime = setTimeout(function () {
              return A.deletionMark = null;
            }, 1e3), this.deletionMark = t) : this.performDeleteTag(t);
          }
        },
        addTagsFromPaste: function addTagsFromPaste() {
          var A = this;
          this.addFromPaste && setTimeout(function () {
            return A.performAddTags(A.newTag);
          }, 10);
        },
        performEditTag: function performEditTag(A) {
          var t = this;
          this.allowEditTags && (this._events["before-editing-tag"] || this.editTag(A), this.$emit("before-editing-tag", {
            index: A,
            tag: this.tagsCopy[A],
            editTag: function editTag() {
              return t.editTag(A);
            }
          }));
        },
        editTag: function editTag(A) {
          this.allowEditTags && (this.toggleEditMode(A), this.focus(A));
        },
        toggleEditMode: function toggleEditMode(A) {
          this.allowEditTags && !this.disabled && this.$set(this.tagsEditStatus, A, !this.tagsEditStatus[A]);
        },
        createChangedTag: function createChangedTag(A, t) {
          var e = this.tagsCopy[A];
          e.text = t ? t.target.value : this.tagsCopy[A].text, this.$set(this.tagsCopy, A, s(e, this.tagsCopy, this.validation, this.isDuplicate));
        },
        focus: function focus(A) {
          var t = this;
          this.$nextTick(function () {
            var e = t.$refs.tagCenter[A].querySelector("input.ti-tag-input");
            e && e.focus();
          });
        },
        quote: function quote(A) {
          return A.replace(/([()[{*+.$^\\|?])/g, "\\$1");
        },
        cancelEdit: function cancelEdit(A) {
          this.tags[A] && (this.tagsCopy[A] = r(s(this.tags[A], this.tags, this.validation, this.isDuplicate)), this.$set(this.tagsEditStatus, A, !1));
        },
        hasForbiddingAddRule: function hasForbiddingAddRule(A) {
          var t = this;
          return A.some(function (A) {
            var e = t.validation.find(function (t) {
              return A === t.classes;
            });
            return !!e && e.disableAdd;
          });
        },
        createTagTexts: function createTagTexts(A) {
          var t = this,
              e = new RegExp(this.separators.map(function (A) {
            return t.quote(A);
          }).join("|"));
          return A.split(e).map(function (A) {
            return {
              text: A
            };
          });
        },
        performDeleteTag: function performDeleteTag(A) {
          var t = this;
          this._events["before-deleting-tag"] || this.deleteTag(A), this.$emit("before-deleting-tag", {
            index: A,
            tag: this.tagsCopy[A],
            deleteTag: function deleteTag() {
              return t.deleteTag(A);
            }
          });
        },
        deleteTag: function deleteTag(A) {
          this.disabled || (this.deletionMark = null, clearTimeout(this.deletionMarkTime), this.tagsCopy.splice(A, 1), this._events["update:tags"] && this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
        },
        noTriggerKey: function noTriggerKey(A, t) {
          var e = -1 !== this[t].indexOf(A.keyCode) || -1 !== this[t].indexOf(A.key);
          return e && A.preventDefault(), !e;
        },
        performAddTags: function performAddTags(A, t, e) {
          var n = this;

          if (!(this.disabled || t && this.noTriggerKey(t, "addOnKey"))) {
            var i = [];
            "object" === m(A) && (i = [A]), "string" == typeof A && (i = this.createTagTexts(A)), (i = i.filter(function (A) {
              return A.text.trim().length > 0;
            })).forEach(function (A) {
              A = s(A, n.tags, n.validation, n.isDuplicate), n._events["before-adding-tag"] || n.addTag(A, e), n.$emit("before-adding-tag", {
                tag: A,
                addTag: function addTag() {
                  return n.addTag(A, e);
                }
              });
            });
          }
        },
        duplicateFilter: function duplicateFilter(A) {
          return this.isDuplicate ? !this.isDuplicate(this.tagsCopy, A) : !this.tagsCopy.find(function (t) {
            return t.text === A.text;
          });
        },
        addTag: function addTag(A) {
          var t = this,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "new-tag-input",
              n = this.filteredAutocompleteItems.map(function (A) {
            return A.text;
          });
          this.addOnlyFromAutocomplete && -1 === n.indexOf(A.text) || this.$nextTick(function () {
            return t.maxTags && t.maxTags <= t.tagsCopy.length ? t.$emit("max-tags-reached", A) : t.avoidAddingDuplicates && !t.duplicateFilter(A) ? t.$emit("adding-duplicate", A) : void (t.hasForbiddingAddRule(A.tiClasses) || (t.$emit("input", ""), t.tagsCopy.push(A), t._events["update:tags"] && t.$emit("update:tags", t.tagsCopy), "autocomplete" === e && t.$refs.newTagInput.focus(), t.$emit("tags-changed", t.tagsCopy)));
          });
        },
        performSaveTag: function performSaveTag(A, t) {
          var e = this,
              n = this.tagsCopy[A];
          this.disabled || t && this.noTriggerKey(t, "addOnKey") || 0 !== n.text.trim().length && (this._events["before-saving-tag"] || this.saveTag(A, n), this.$emit("before-saving-tag", {
            index: A,
            tag: n,
            saveTag: function saveTag() {
              return e.saveTag(A, n);
            }
          }));
        },
        saveTag: function saveTag(A, t) {
          if (this.avoidAddingDuplicates) {
            var e = r(this.tagsCopy),
                n = e.splice(A, 1)[0];
            if (this.isDuplicate ? this.isDuplicate(e, n) : -1 !== e.map(function (A) {
              return A.text;
            }).indexOf(n.text)) return this.$emit("saving-duplicate", t);
          }

          this.hasForbiddingAddRule(t.tiClasses) || (this.$set(this.tagsCopy, A, t), this.toggleEditMode(A), this._events["update:tags"] && this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
        },
        tagsEqual: function tagsEqual() {
          var A = this;
          return !this.tagsCopy.some(function (t, e) {
            return !a()(t, A.tags[e]);
          });
        },
        updateNewTag: function updateNewTag(A) {
          var t = A.target.value;
          this.newTag = t, this.$emit("input", t);
        },
        initTags: function initTags() {
          this.tagsCopy = u(this.tags, this.validation, this.isDuplicate), this.tagsEditStatus = r(this.tags).map(function () {
            return !1;
          }), this._events["update:tags"] && !this.tagsEqual() && this.$emit("update:tags", this.tagsCopy);
        },
        blurredOnClick: function blurredOnClick(A) {
          this.$el.contains(A.target) || this.$el.contains(document.activeElement) || this.performBlur(A);
        },
        performBlur: function performBlur() {
          this.addOnBlur && this.focused && this.performAddTags(this.newTag), this.focused = !1;
        }
      },
      watch: {
        value: function value(A) {
          this.addOnlyFromAutocomplete || (this.selectedItem = null), this.newTag = A;
        },
        tags: {
          handler: function handler() {
            this.initTags();
          },
          deep: !0
        },
        autocompleteOpen: "selectDefaultItem"
      },
      created: function created() {
        this.newTag = this.value, this.initTags();
      },
      mounted: function mounted() {
        this.selectDefaultItem(), document.addEventListener("click", this.blurredOnClick);
      },
      destroyed: function destroyed() {
        document.removeEventListener("click", this.blurredOnClick);
      }
    },
        C = (e(9), l(h, n, [], !1, null, "61d92e31", null));
    C.options.__file = "vue-tags-input/vue-tags-input.vue";
    var E = C.exports;
    e.d(t, "VueTagsInput", function () {
      return E;
    }), e.d(t, "createClasses", function () {
      return o;
    }), e.d(t, "createTag", function () {
      return s;
    }), e.d(t, "createTags", function () {
      return u;
    }), e.d(t, "TagInput", function () {
      return g;
    }), E.install = function (A) {
      return A.component(E.name, E);
    }, "undefined" != typeof window && window.Vue && window.Vue.use(E);
    t.default = E;
  }]);
});